import { render, staticRenderFns } from "./expenseView.vue?vue&type=template&id=6d90867c&scoped=true"
import script from "./expenseView.vue?vue&type=script&lang=js"
export * from "./expenseView.vue?vue&type=script&lang=js"
import style0 from "./expenseView.vue?vue&type=style&index=0&id=6d90867c&prod&lang=scss&scoped=true"
import style1 from "./expenseView.vue?vue&type=style&index=1&id=6d90867c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90867c",
  null
  
)

export default component.exports